import React, { useState } from 'react';

import { Button } from '@/components/ui/catalyst/button';
import { useMatter } from '@/hooks/useMatter';
import { TreatmentRecordRequestSchema } from '@/services/api/generated/treatmentRecordRequestsService';
import { treatmentRecordRequestService } from '@/services/api/treatmentRecordRequestService';
import { MedicalProvider } from '@/services/types/treatment-types';

import { ActivityLogTimeline } from '../../../activity-log/ActivityLogTimeline';
import { AddLogEntryForm } from '../../../activity-log/AddLogEntryForm';

interface RequestCardActivityLogProps {
  request: TreatmentRecordRequestSchema;
  provider: MedicalProvider;
}

export const RequestCardActivityLog: React.FC<RequestCardActivityLogProps> = ({
  request,
  provider,
}) => {
  const { matterId } = useMatter();
  const [showAddNoteForm, setShowAddNoteForm] = useState(false);

  const {
    data: logs,
    isLoading,
    error,
    refetch,
  } = treatmentRecordRequestService.useMattersProvidersRecordRequestsAuditLogsListQuery(
    {
      matterId,
      providerId: provider.id,
      requestId: request.id,
    },
    {
      pollingInterval: 10_000,
    },
  );

  const handleAddNoteSuccess = () => {
    setShowAddNoteForm(false);
    refetch();
  };

  const handleCancelAddNote = () => {
    setShowAddNoteForm(false);
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Activity log timeline */}
      <div className="py-2">
        <ActivityLogTimeline
          auditLogs={logs || []}
          isLoading={isLoading}
          error={error}
        />
      </div>

      {/* Add note section */}
      <div className="border-t border-gray-200 pt-4">
        {!showAddNoteForm ? (
          <Button
            onClick={() => setShowAddNoteForm(true)}
            outline
            className="text-sm"
          >
            Add Note
          </Button>
        ) : (
          <div className="max-w-2xl">
            <AddLogEntryForm
              request={request}
              provider={provider}
              onCancel={handleCancelAddNote}
              onSuccess={handleAddNoteSuccess}
              autoFocus
            />
          </div>
        )}
      </div>
    </div>
  );
};
